import {EMissionType} from "@/shared/enums/mission-type";

const TYPE_MISSION_NAME_KEY = {
    [EMissionType.ENTIRE_COLUMNS_1]: 'dashboard-widget.board_col_1',
    [EMissionType.ENTIRE_COLUMNS_2]: 'dashboard-widget.board_col_2',
    [EMissionType.COVER]: 'dashboard-widget.board_cover',
    [EMissionType.VORSATZ]: 'dashboard-widget.board_vorsats',
}

export {TYPE_MISSION_NAME_KEY};